import { useSite } from "../context/SiteContentContext";

export const Gallery = () => {
    const siteConfig = useSite();
    const [g1, g2, g3, g4, g5] = siteConfig.gallery;
    return (
        <section
            id="gallery"
            data-testid="gallery-section"
            className="relative py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a]"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
                    <div>
                        <div className="ornamental-divider mb-6">
                            <span>Galeria</span>
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-none text-[#f5f5f0]">
                            Do estúdio
                            <br />
                            <span className="italic font-normal text-[#a3a3a3]">
                                para o retrato.
                            </span>
                        </h2>
                    </div>
                    <p className="max-w-sm text-sm text-[#a3a3a3] leading-relaxed">
                        Uma amostra dos nossos cortes, ambiente e ferramentas.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 grid-rows-2 gap-4 md:gap-6 auto-rows-[200px] md:auto-rows-[260px]">
                    <GalleryTile
                        img={g1}
                        className="md:col-span-5 md:row-span-2"
                        testId="gallery-tile-1"
                    />
                    <GalleryTile
                        img={g2}
                        className="md:col-span-4"
                        testId="gallery-tile-2"
                    />
                    <GalleryTile
                        img={g3}
                        className="md:col-span-3"
                        testId="gallery-tile-3"
                    />
                    <GalleryTile
                        img={g4}
                        className="md:col-span-3"
                        testId="gallery-tile-4"
                    />
                    <GalleryTile
                        img={g5}
                        className="md:col-span-4"
                        testId="gallery-tile-5"
                    />
                </div>
            </div>
        </section>
    );
};

const GalleryTile = ({ img, className, testId }) => (
    <div
        data-testid={testId}
        className={`relative overflow-hidden group ${className}`}
    >
        <img
            src={img.url}
            alt={img.alt}
            className="w-full h-full object-cover grayscale transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a]/60 to-transparent opacity-60 group-hover:opacity-30 transition-opacity duration-500" />
    </div>
);
